module.exports = __webpack_public_path__ + "static/media/tr.1a22d127.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tr.svg
// module id = 2230
// module chunks = 0